import CommandHelmGetRepoSnippet from "../../../../contents/docs/self-host/_snippets/command-helm-get-repo";
import CommandHelmUpgradeSnippet from "../../../../contents/docs/self-host/_snippets/command-helm-upgrade";
import * as React from 'react';
export default {
  CommandHelmGetRepoSnippet,
  CommandHelmUpgradeSnippet,
  React
};